import React from 'react';
import { MAP_ELEMENT } from '../../../../contexts/WorldMapContext/constants';
import { convertNumberTimeToStringTime } from "../../../../util/varibles/global";
import { IPois } from "../../../../util/varibles/interface";
import FishDisease from "../../_components/FishDisease";
import Phone from "../../_components/Phone";
import Position from "../../_components/Position";
import Region from "../../_components/Region";
import Weather from "../../_components/Weather";
import stylesParent from "../style.module.scss";
import styles from "./style.module.scss";

interface IProps {
    data: IPois
}

const Poi: React.FC<IProps> = ({ data }) => {
    const { id, name, phone, diseases, position, work_time } = data;

    return <>
        <div className={stylesParent.header}>
            <div className='flex align-items-center'>
                <span>{name}</span>
                <span className='ml-5 italic text-comment font-s4 pt-2'> - POI</span>
            </div>
        </div>
        <div className={stylesParent.body}>
            <div className={styles['container-info']}>
                <div className={styles.title}>
                    <div>POI info.</div>
                </div>
                <Phone phone={phone} />
                <div className={styles['line-info']}>
                    <span>Work time:</span>
                    <span>{convertNumberTimeToStringTime((Number(work_time) || 0) * 60000)}</span>
                </div>
                <Region regionId={data.region_id} />
                <Position {...{ lat: position.latitude, lng: position.longitude }} />
            </div>
            <div className={styles['container-weather']}>
                <Weather data={{ id, name, type: MAP_ELEMENT.POI }} />
            </div>
            <div className={[styles['container-weather'], 'pb-0'].join(' ')}>
                <div className={styles.title}>
                    <div>Disease</div>
                </div>
                <div className='text-comment ml-20 font-s4'>
                    (The info. is for current week and will be updated each week)
                </div>
                <FishDisease data={diseases} is_lice={false} />
            </div>
        </div>
    </>;
};

export default Poi;
